import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '@digital-realty/ix-toast/ix-toasters.js';
import fetchMock from 'fetch-mock';
import './ix-notifications.js';
import './components/icons/notifications-icon.js';
import config from '../config.json';
import { fixtureMockApi } from '../test/utils/helpers.js';

export const apiCallKey = 'getNotifications';

@customElement('notifications-test-harness')
export class NotificationsTestHarness extends LitElement {
  @property({ type: Boolean }) enableMock = false;

  firstUpdated() {
    if (this.enableMock) {
      fixtureMockApi();
    }
  }

  disconnectedCallback() {
    // eslint-disable-next-line wc/guard-super-call
    super.disconnectedCallback();
    if (this.enableMock) {
      fetchMock.hardReset({ includeSticky: true });
    }
  }

  render() {
    return html`
      Note: this data is mocked by the test harness. To enable the real data,
      set the enableMock property to false and provide a valid auth token.
      <notifications-icon></notifications-icon>
      <ix-toasters> </ix-toasters>
      <ix-notifications
        data-theme="ix-theme"
        baseApiUrl=${config.baseApiUrl}
        localStorageKey="user-authentication"
      >
      </ix-notifications>
    `;
  }
}
